export const adminCommunity = {
  // Community Genealogy Tree Admin Page
  "admin.community.communityGenealogyTree.title": "Árbol Genealógico de la Comunidad",
  "admin.community.communityGenealogyTree.subtitle": "Visualiza y explora la estructura completa de referidos",
  "admin.community.communityGenealogyTree.loading": "Cargando árbol genealógico...",
  "admin.community.communityGenealogyTree.error": "Error al cargar el árbol genealógico",
  "admin.community.communityGenealogyTree.searchLabel": "Buscar por nombre de usuario",
  "admin.community.communityGenealogyTree.searchPlaceholder": "Ingresa nombre de usuario...",
  "admin.community.communityGenealogyTree.searchButton": "Cargar Árbol",
  "admin.community.communityGenealogyTree.resetButton": "Restablecer Vista",
  "admin.community.communityGenealogyTree.userNotFound": "Usuario no encontrado",
  "admin.community.communityGenealogyTree.searchError": "Error al buscar usuario",
  "admin.community.communityGenealogyTree.invalidUser": "Usuario inválido especificado",
  
  // Tree Node Actions
  "admin.community.treeNode.expand": "Expandir",
  "admin.community.treeNode.collapse": "Contraer",
  "admin.community.treeNode.directReferrals": "Referidos Directos",
  "admin.community.treeNode.loading": "Cargando...",
  
  // Error Messages
  "admin.community.errors.accessDenied": "Acceso denegado: permisos insuficientes",
  "admin.community.errors.userNotFound": "Usuario no encontrado",
  "admin.community.errors.networkError": "Recargar Página",
  "admin.community.errors.unexpectedError": "Ocurrió un error inesperado"
};